export const AVAILABILITY_COLORS = {
  AVAILABLE_BLOCKED: { bg: '#686868', font: 'white' },
  UNAVAILABLE_BLOCKED: { bg: '#ee5858', font: 'white' },
  AVAILABLE_OWNER_CHANNEL: { bg: '#eae23f', font: 'black' },
  UNAVAILABLE_OWNER_CHANNEL: { bg: '#9610ad', font: 'white' }
}
